import * as tf from '@tensorflow/tfjs';
import Utils from './utils';

const TYPE_EYE = 0;
const TYPE_HEAD = 1;
const leftIris = [474, 475, 476, 477];
const rightIris = [469, 470, 471, 472];
const leftEye = [249, 263, 362, 373, 374, 380, 381, 382, 384, 385, 386, 387, 388, 390, 398, 466];
const rightEye = [7, 33, 133, 144, 145, 153, 154, 155, 157, 158, 159, 160, 161, 163, 173, 246];
const leftEyebrow = [276, 282, 283, 293, 295, 296, 300, 334, 336];
const rightEyebrow = [46, 52, 53, 63, 65, 66, 70, 105, 107];
const tempEye = [];
const tempHead = [];
const dataset = {
  eye_train: {
    n: 0,
    x: null,
    y: null,
  },
  eye_val: {
    n: 0,
    x: null,
    y: null,
  },
  head_train: {
    n: 0,
    x: null,
    y: null,
  },
  head_val: {
    n: 0,
    x: null,
    y: null,
  },
  eyeSize: leftIris.length + rightIris.length + leftEye.length + rightEye.length,
  bodyHeight: document.body.clientHeight,
  bodyWidth: document.body.clientWidth,

  getRect: function (face, arr) {
    let minX = dataset.bodyWidth;
    let maxX = 0;
    let minY = dataset.bodyHeight;
    let maxY = 0;
    for (let i = 0; i < arr.length; i++) {
      let value = face.keypoints[arr[i]];

      if (value.x < minX)
        minX = value.x;
      if (value.x > maxX)
        maxX = value.x;
      if (value.y < minY)
        minY = value.y;
      if (value.y > maxY)
        maxY = value.y;
    }
    return [minX, minY, maxX, maxY];
  },


  getPartArr: function (arr, face, part, rect) {
    let width = rect[2] - rect[0];
    let height = rect[3] - rect[1];
    for (let i = 0; i < part.length; i++) {
      arr.push([(face.keypoints[part[i]].x - rect[0]) / width - 0.5,
      (face.keypoints[part[i]].y - rect[1]) / height - 0.5,
      face.keypoints[part[i]].z / width]);
    }
  },
  //获取眼球数组
  getEyeArr: function (face, arr) {
    let rectArr = [];
    rectArr.push(...leftEye, ...leftIris, ...leftEyebrow);
    let leftrect = dataset.getRect(face, rectArr);
    dataset.getPartArr(arr, face, rectArr, leftrect);
    rectArr = [];
    rectArr.push(...rightEye, ...rightIris, ...rightEyebrow);
    let rightrect = dataset.getRect(face, rectArr);
    dataset.getPartArr(arr, face, rectArr, rightrect);
  },

  getHeadArr: function (face, arr) {
    for (let i = 0; i < face.keypoints.length; i++) {
      arr.push([(face.keypoints[i].x - face.box.xMin) / face.box.width - 0.5,
      (face.keypoints[i].y - face.box.yMin) / face.box.height - 0.5,
      face.keypoints[i].z / face.box.height]);
    }
  },

  getExampleEyeArr: function (face) {
    let arr = [];
    dataset.getEyeArr(face, arr);

    return tf.tidy(function () {
      return tf.tensor2d(arr).expandDims(0);
    });
  },
  getExampleHeadArr: function (face) {
    let arr = [];
    dataset.getHeadArr(face, arr);

    return tf.tidy(function () {
      return tf.tensor2d(arr).expandDims(0);
    });
  },

  whichDataset: function (type) {
    // Returns 'train' or 'val' depending on what makes sense / is random.
    // if (dataset.train.n === 0) {
    //   return type+'_train';
    // }
    // if (dataset.val.n === 0) {
    //   return type+'_val';
    // }
    return type + (Math.random() < 0.2 ? '_val' : '_train');
  },

  addToDataset: function (dat, target, key) {
    // Add the given x, y to either 'train' or 'val'.
    const set = dataset[key];

    if (set.x == null) {
      set.x = tf.keep(dat);
      set.y = tf.keep(target);
    } else {
      const oldX = set.x;
      set.x = tf.keep(oldX.concat(dat, 0));

      const oldY = set.y;
      set.y = tf.keep(oldY.concat(target, 0));

      tf.dispose([oldX, oldY, target]);
    }

    set.n += 1;
  },

  addExample: function (dat, target, type) {
    // Given an image, eye pos and target coordinates, adds them to our dataset.
    target = tf.keep(
      tf.tidy(function () {
        return tf.tensor1d(target).expandDims(0);
      }),
    );
    const key = dataset.whichDataset(type);
    // eyes.print();
    // console.log(eyes.shape)
    // target.print();
    dataset.addToDataset(dat, target, key);
  },

  captureExample: async function (face, x, y, state, type) {
    // Take the latest image from the eyes canvas and add it to our dataset.
    // Takes the coordinates of the mouse.
    if (state === Utils.Type_Calibration.temp) {
      if (type === "head")
        tempHead.push([face, x, y]);
      tempEye.push([face, x, y]);
    } else {
      tempEye.forEach(dat => {
        tf.tidy(function () {
          let img = dataset.getExampleEyeArr(dat[0]);
          const mousePos = [dat[1] - 0.5, dat[2] - 0.5];
          dataset.addExample(img, mousePos, 'eye');
        });
      });
      tempEye.length = 0;
      tempHead.forEach(dat => {
        tf.tidy(function () {
          let img = dataset.getExampleHeadArr(dat[0]);
          const mousePos = [dat[1] - 0.5, dat[2] - 0.5];
          dataset.addExample(img, mousePos, 'head');
        });
      });
      tempHead.length = 0;
    }
  },

}
export default dataset;